import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

console.log('Vuetify.version:', Vuetify.version);

Vue.use(Vuetify);

export default new Vuetify({
});
